import axios from 'axios';

const authAxios = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API
});

export default authAxios;
